import React from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ProductRow from "./ProductRow";
import ProductHistoryHeader from "./ProductHistoryHeader";

/** Hook から渡された全ての prop を受け取る */
const ProductHistoryModal = ({
  open,
  closeModal,
  /* データ */
  displayed,
  hidden,
  /* 選択 */
  selected,
  toggleSelect,
  /* ハンドラ */
  handleHide,
  handleBack,
  handleBulkHide,
  handleBulkBack,
  handleToggleAllDisplayed,
  handleToggleAllHidden,
}) => (
  <Modal open={open} onClose={closeModal}>
    <Box
      sx={{
        width: "95vw", // ① 95 vw
        height: "90vh",
        bgcolor: "#fff",
        borderRadius: 3,
        p: 4,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow: 24,
        overflow: "hidden", // ② wrapper cố định; cuộn trong từng cột
      }}
    >
      {/* ✖︎ */}
      <IconButton
        onClick={closeModal}
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>

      <Typography variant="h5" fontWeight={600} mb={2} textAlign="center">
        発注商品履歴
      </Typography>

      {/* ============== two-column layout ============== */}
      <Stack
        direction="row"
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
        sx={{ height: "calc(100% - 72px)" }} // 72 = title + margin
      >
        {/* ---------- 表示中 ---------- */}
        <Box sx={{ flex: 1, minWidth: 0, overflow: "auto", pr: 1 }}>
          <Typography variant="subtitle1" fontWeight={600}>
            表示中
          </Typography>
          <Divider sx={{ mb: 1 }} />

          {/* Bulk 操作 */}
          <Grid container spacing={1} sx={{ mb: 1 }} justifyContent="flex-end">
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={handleToggleAllDisplayed}
              >
                {selected.displayed.length === displayed.length
                  ? "全解除"
                  : "全選択"}
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="contained"
                color="error"
                disabled={selected.displayed.length === 0}
                onClick={handleBulkHide}
              >
                一括非表示
              </Button>
            </Grid>
          </Grid>

          <ProductHistoryHeader />
          {displayed.length === 0 ? (
            <Typography color="text.secondary">データがありません。</Typography>
          ) : (
            displayed.map((rep) => (
              <ProductRow
                key={rep._groupKey}
                product={rep}
                selected={selected.displayed.includes(rep._groupKey)}
                onSelect={() => toggleSelect(rep, false)}
                actions={[
                  <Button
                    key="hide"
                    size="small"
                    variant="outlined"
                    color="error"
                    onClick={() => handleHide(rep)}
                  >
                    非表示
                  </Button>,
                ]}
              />
            ))
          )}
        </Box>

        {/* ---------- 非表示 ---------- */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            overflowY: "auto",
            pl: 1,
            overflowX: "hidden",
          }}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            非表示
          </Typography>
          <Divider sx={{ mb: 1 }} />

          {/* Bulk 操作 */}
          <Grid
            container
            spacing={1}
            sx={{ mb: 1, overFlowX: "hidden" }}
            justifyContent="flex-end"
          >
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={handleToggleAllHidden}
              >
                {selected.hidden.length === hidden.length ? "全解除" : "全選択"}
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="contained"
                disabled={selected.hidden.length === 0}
                onClick={handleBulkBack}
              >
                一括表示
              </Button>
            </Grid>
          </Grid>

          <ProductHistoryHeader />
          {hidden.length === 0 ? (
            <Typography color="text.secondary">
              非表示の商品はありません。
            </Typography>
          ) : (
            hidden.map((rep) => (
              <ProductRow
                key={rep._groupKey}
                product={rep}
                selected={selected.hidden.includes(rep._groupKey)}
                onSelect={() => toggleSelect(rep, true)}
                actions={[
                  <Button
                    key="back"
                    size="small"
                    variant="outlined"
                    onClick={() => handleBack(rep)}
                  >
                    表示
                  </Button>,
                ]}
              />
            ))
          )}
        </Box>
      </Stack>
    </Box>
  </Modal>
);

export default ProductHistoryModal;
